import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/fiscal/certificado-digital' };
/////////////////////////////////////////////////////////////////////////////////

export function createCertificadoDigitalCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateCertificadoDigitalCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listCertificadoDigitalCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findCertificadoDigitalCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllCertificadoDigitalCadastro() {
  return httpService.get({ ...args, path: '/fiscal/certificado-digital/all' });
}

export function deleteCertificadoDigitalCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

export function validarCertificado(certificado, senha) {
  var bodyFormData = new FormData();
  bodyFormData.append('certificado', certificado);
  // senha no corpo (não mais na URL) e validação feita no central
  bodyFormData.append('senha', senha);

  return httpService.postFile({ ...path, path: '/fiscal/monitoramento-nfe-compra', args: '/validar-certificado' }, bodyFormData);
}


export function getNroCpfCnpjMonitoradosNFeCompra() {
  return httpService.get({ ...args, args: `/nroCpfCnpjMonitoradosNFeCompra` });
}